import React from 'react';
import { HashLink } from 'react-router-hash-link';
import '../styles/FooterStyle.css';
import Logo from "../../assets/logo1.png";
import navIcon5 from "../../assets/nav-icon5.svg";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faEnvelope, faMapMarker } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';


library.add(faPhone, faEnvelope, faMapMarker);


export const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <footer>
      <section className='footer-top-wrapper'>
        <section className="footer-top">
        <div className="logo">
        <img src={Logo} alt="Logo Simcor" />
      </div>
          <span className='social-icon'>
            <a href="https://wa.me/3515291902">
              <img src={navIcon5} alt="Social Icon" />
            </a>
          </span>
        </section>

        <section>
          <menu className='menu-footer-meta'>
            <h2>Powered by</h2>
            <Link to="https://metacode.com.ar" target="_blank" className='metacode'>
            Metacode
            </Link>
              </menu>
            </section>

        <section>
          <menu className='menu-footer'>
            <h2>Simcor</h2>
            <li>
              <HashLink to="/about" className='footer-links'>Nosotros</HashLink>
            </li>
            <li>
              <HashLink to="/services" className='footer-links'>Servicios</HashLink>
            </li>
          </menu>
        </section>

        <section>
          <menu className='menu-footer'>
            <h2>Contactate</h2>
            <FontAwesomeIcon icon="phone" />
            <p>+54 9 3515 29-1902</p>
            <FontAwesomeIcon icon="envelope" />
            <p>gabysimcor@hotmail.com</p>
            <FontAwesomeIcon icon="map-marker" />
            <p>Virgilio Moyano 1266</p>
          </menu>
        </section>

        <section className='footer-bottom'>
          <small>&copy; {year} Derechos de autor. Todos los derechos reservados.</small>
        </section>
      </section>
    </footer>
  );
}

export default Footer;